// extracted by mini-css-extract-plugin
export default {"mainBlock":"Main_mainBlock__U2pwc","particles":"Main_particles__3MWRO","text":"Main_text__LiqJk","mainText":"Main_mainText__+ulNw","photo":"Main_photo__sPGaQ"};